import { useState } from "react";
import { useToast } from "../hooks/use-toast";
import { Send } from "lucide-react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { SERVICE_LIST_FOR_FORM } from "../mock";

export default function ContactForm() {
  const { toast } = useToast();
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "", mobile: "", altMobile: "",
    amount: "", service: "", city: "", captcha: "",
  });
  const [a, b] = [3, 4];

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target?.value ?? e });

  const submit = (e) => {
    e.preventDefault();
    if (Number(form.captcha) !== a + b) {
      toast({ title: "Captcha incorrect", description: "Please solve the arithmetic question.", variant: "destructive" });
      return;
    }
    if (!form.firstName || !form.email || !form.mobile || !form.service) {
      toast({ title: "Missing fields", description: "Please fill required fields.", variant: "destructive" });
      return;
    }
    // Save to localStorage (mock)
    const prev = JSON.parse(localStorage.getItem("fortunexis_leads") || "[]");
    prev.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem("fortunexis_leads", JSON.stringify(prev));
    toast({ title: "Thanks, we've got your enquiry!", description: "A consultant from Fortunexis LLC will contact you shortly." });
    setForm({ firstName: "", lastName: "", email: "", mobile: "", altMobile: "", amount: "", service: "", city: "", captcha: "" });
  };

  return (
    <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
      <h3 className="text-[#0a2540] font-bold text-2xl">Send us a message</h3>
      <p className="text-sm text-slate-500 mt-1">All fields marked * are required</p>

      <div className="grid sm:grid-cols-2 gap-4 mt-6">
        <div>
          <label className="text-xs font-semibold text-slate-600">First Name *</label>
          <Input value={form.firstName} onChange={onChange("firstName")} placeholder="John" className="mt-1" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Last Name</label>
          <Input value={form.lastName} onChange={onChange("lastName")} placeholder="Doe" className="mt-1" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Email *</label>
          <Input type="email" value={form.email} onChange={onChange("email")} placeholder="you@company.com" className="mt-1" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Mobile *</label>
          <Input value={form.mobile} onChange={onChange("mobile")} placeholder="+971 5x xxx xxxx" className="mt-1" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Alternate Mobile</label>
          <Input value={form.altMobile} onChange={onChange("altMobile")} placeholder="Optional" className="mt-1" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">Amount Required</label>
          <Input value={form.amount} onChange={onChange("amount")} placeholder="e.g. 5,000,000" className="mt-1" />
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-semibold text-slate-600">Select Service *</label>
          <Select value={form.service} onValueChange={(v) => setForm({ ...form, service: v })}>
            <SelectTrigger className="mt-1"><SelectValue placeholder="Choose a service" /></SelectTrigger>
            <SelectContent>
              {SERVICE_LIST_FOR_FORM.map((s) => (
                <SelectItem key={s} value={s}>{s}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">City</label>
          <Input value={form.city} onChange={onChange("city")} placeholder="Dubai" className="mt-1" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-600">{a} + {b} = ?</label>
          <Input value={form.captcha} onChange={onChange("captcha")} placeholder="Answer" className="mt-1" />
        </div>
      </div>

      <Button type="submit" className="mt-6 w-full bg-[#1e40af] hover:bg-[#0f3562] text-white h-12">
        <Send size={16} className="mr-2" /> Submit Enquiry
      </Button>
    </form>
  );
}
